
  const textElement = document.getElementById("texttypewrite");
  const originalHTML = textElement.innerHTML;
  textElement.innerHTML = "";

  let index = 0;
  const speed = 50;

  // Creamos un contenedor temporal para parsear los nodos HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = originalHTML;
  const nodes = Array.from(tempDiv.childNodes);

  function typeNode(node, parent, callback) {
    if (node.nodeType === Node.TEXT_NODE) {
      // Si es un texto plano
      const text = node.textContent;
      let i = 0;
      function typeChar() {
        if (i < text.length) {
          parent.appendChild(document.createTextNode(text.charAt(i)));
          i++;
          setTimeout(typeChar, speed);
        } else {
          callback();
        }
      }
      typeChar();
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      // Si es una etiqueta HTML (como <strong>)
      const newElement = document.createElement(node.tagName);
      for (let attr of node.attributes) {
        newElement.setAttribute(attr.name, attr.value);
      }
      parent.appendChild(newElement);
      typeChildren(Array.from(node.childNodes), newElement, callback);
    } else {
      callback();
    }
  }

  function typeChildren(nodes, parent, callback) {
    if (nodes.length === 0) {
      callback();
      return;
    }
    typeNode(nodes[0], parent, () => {
      typeChildren(nodes.slice(1), parent, callback);
    });
  }

  function typeAllNodes() {
    typeChildren(nodes, textElement, () => {
      // Animación completada
    });
  }

  const observer = new IntersectionObserver((entries, observer) => {
    if (entries[0].isIntersecting) {
      typeAllNodes();
      observer.disconnect();
    }
  }, {
    threshold: 1.0
  });

  observer.observe(textElement);

let logoScrollers = {};

function initiateLogoScroller(container = document) {
  const rows = container.querySelectorAll(".logo-scroller-row");

  rows.forEach(row => {
    // Kill any existing animation for this row
    if (logoScrollers[row]) {
      logoScrollers[row].kill();
      delete logoScrollers[row];
    }

    const rowItems = Array.from(row.children);
    let rowWidth = row.scrollWidth;
    const containerWidth = window.innerWidth;

    // Prevent duplicate cloning
    if (!row.dataset.cloned) {
      let totalWidth = rowWidth;

      // Clone logos until the total width is at least twice the viewport width
      while (totalWidth < containerWidth * 4) {
        rowItems.forEach(item => {
          const clone = item.cloneNode(true);
          row.appendChild(clone);
          totalWidth += item.offsetWidth;
        });
      }

      rowWidth = row.scrollWidth; // Update rowWidth after cloning
      row.dataset.cloned = "true";
    }

    // Reset row position to start
    gsap.set(row, { x: 0 });

    // Calculate speed dynamically to maintain consistency
    let baseSpeed = 5;
    let duration = (rowWidth / containerWidth) * baseSpeed;

    if (window.innerWidth < 768) {
      duration *= 1.5; // Slow it down for mobile
    }

    // GSAP Infinite Scrolling
    const tl = gsap.timeline({ repeat: -1, ease: "none" });

    tl.to(row, {
      x: `-${rowWidth / 2}px`, // Move by half the total width
      duration: duration,
      ease: "none",
      onComplete: function () {
        gsap.set(row, { x: 0 }); // Reset position to loop seamlessly
      }
    });

    // Store the timeline for future cleanup
    logoScrollers[row] = tl;

    // Pause and resume on hover/touch
    row.addEventListener("mouseenter", () => tl.pause());
    row.addEventListener("mouseleave", () => tl.resume());
    row.addEventListener("touchstart", () => tl.pause());
    row.addEventListener("touchend", () => tl.resume());
  });
}

// Initialize on page load
initiateLogoScroller(document);

// Re-initiate in AJAX overlay
function loadNewContentViaAjax() {
  setTimeout(() => {
    const ajaxContainer = document.querySelector(".ajax-overlay");
    if (ajaxContainer) {
      initiateLogoScroller(ajaxContainer);
    }
  }, 1000);
}

